import React, { useCallback, useContext } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import {
    fetchRelatedRecords,
    useDataProvider,
    useNotify,
    ExporterContext,
    Button,
    useResourceContext
} from 'react-admin';
import logger from '../../utils/logger';

const ExportButton = ({
    sort,
    filter = defaultFilter,
    maxResults = 999999999,
    onClick,
    label = 'ra.action.export',
    icon = defaultIcon,
    exporter: customExporter,
    ...rest
}) => {
    const exporterFromContext = useContext(ExporterContext);
    const exporter = customExporter || exporterFromContext;
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const resource = useResourceContext();
    const handleClick = useCallback(
        event => {
            dataProvider
                .getList(resource, {
                    sort,
                    filter,
                    pagination: { page: 1, perPage: maxResults },
                    export: true
                })
                .then(
                    ({ data }) =>
                        exporter &&
                        exporter(
                            data,
                            fetchRelatedRecords(dataProvider),
                            dataProvider,
                            resource
                        )
                )
                .catch(error => {
                    logger.error(error);
                    notify('ra.notification.http_error', 'warning');
                });
            if (typeof onClick === 'function') {
                onClick(event);
            }
        },
        [
            dataProvider,
            exporter,
            filter,
            maxResults,
            notify,
            onClick,
            resource,
            sort,
        ]
    );

    return (
        <Button
            onClick={handleClick}
            label={label}
            // {...sanitizeRestProps(rest)}
        >
            {icon}
        </Button>
    );
};

const defaultIcon = <DownloadIcon />;
const defaultFilter = {};

export default ExportButton;